import { API_URL } from 'src/common/utils/api/fetchWrapper';

/**
 * Fetches an API path as the signed-in user and saves the response under the filename from its
 * Content-Disposition header, or `fallbackFilename` when the header has none.
 */
export async function downloadFromApi(path: string, fallbackFilename: string): Promise<void> {
  const response = await fetch(`${API_URL}${path}`, { method: 'GET', credentials: 'include' });

  if (!response.ok) {
    throw new Error(`Download of ${path} failed: ${response.statusText}`);
  }

  const disposition = response.headers.get('Content-Disposition') ?? '';
  const filename = /filename="?([^";]+)"?/.exec(disposition)?.[1] ?? fallbackFilename;
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
